/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Job_Detail_Meeting_Link_EditInputs */

const en_company_job_detail_meeting_link_edit = /** @type {(inputs: Company_Job_Detail_Meeting_Link_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit meeting link`)
};

const de_company_job_detail_meeting_link_edit = /** @type {(inputs: Company_Job_Detail_Meeting_Link_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting-Link bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit meeting link" |
*
* @param {Company_Job_Detail_Meeting_Link_EditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_job_detail_meeting_link_edit = /** @type {((inputs?: Company_Job_Detail_Meeting_Link_EditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Job_Detail_Meeting_Link_EditInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_job_detail_meeting_link_edit(inputs)
	return en_company_job_detail_meeting_link_edit(inputs)
});